export const INTERNALANNOUNCEMENT_DELETE_RESET = 'INTERNALANNOUNCEMENT_DELETE_RESET'
export const INTERNALANNOUNCEMENT_DELETE_SET_ERROR = 'INTERNALANNOUNCEMENT_DELETE_SET_ERROR'
export const INTERNALANNOUNCEMENT_DELETE_SET_DELETED = 'INTERNALANNOUNCEMENT_DELETE_SET_DELETED'
export const INTERNALANNOUNCEMENT_DELETE_TOGGLE_LOADING = 'INTERNALANNOUNCEMENT_DELETE_TOGGLE_LOADING'
